import { Stack, Typography } from '@mui/material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import SmartSelect from '../generic/smartSelect/SmartSelect'
import React from 'react'
import theme from '../../themeConfig'

/**
 * @typedef {import('../generic/utilities/objectStructures/materialreception/materialReception').DeliveryNoteDataAction} DeliveryNoteDataAction DataAction object
 * @typedef {import('../generic/utilities/objectStructures/materialreception/materialReception').DeliveryNote} DeliveryNote Data object
 * @typedef {import('../generic/utilities/objectStructures/materialreception/materialReception').PurchaseOrderTheoreticalReception} PurchaseOrderTheoreticalReception PurchaseOrderTheoreticalReception object
 */

/**
 *
 * @param {object} props
 * @param {import('../generic/utilities/objectStructures/materialreception/materialReception').Requirement} props.requirement
 * @param {string[]} props.qr
 * @param {function(number number)} props.setQr
 * @param {string[]} props.purchaseOrderQrValue
 * @param {boolean} props.locked
 * @returns {JSX.Element}
 */
const Requirement = ({ requirement, qr, setQr, purchaseOrderQrValue, locked = false }) => {
  const { t_ } = useSmartTranslation()

  const selectedValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return ''
    }
    if (value === '1') {
      return 'OK'
    }
    return 'NOK'
  }

  return (
    <>
      <Stack direction='row' justifyContent='space-around' sx={{ minWidth: 'min(80vw, 1200px)', margin: '2rem' }}>
        <Stack direction='row' gap={3}>
          <Typography variant='h5'>{t_('Document number:')}</Typography>
          <Typography variant='h5'>{requirement?.documentName}</Typography>
          <Typography variant='h5'>{requirement?.revision}</Typography>
        </Stack>
      </Stack>
      <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content 1fr', gap: '1rem', alignItems: 'center' }}>
        {purchaseOrderQrValue.map((digit, index) => {
          return (
            <React.Fragment key={index}>
              <Typography key={'d' + index}>{'D' + (index + 1) + '=' + digit}</Typography>
              <SmartSelect
                disabled={digit === 0 || digit === '0' || locked}
                key={'SmartSelect' + index}
                selectableOptions={['OK', 'NOK']}
                value={selectedValue(qr[index])}
                minWidth='6rem'
                onChange={(selected) => {
                  let newValue = 0
                  if (selected === 'OK') {
                    newValue = 1
                  }
                  setQr(newValue, index)
                }}
              />
              <textarea disabled={digit === 0 || digit === '0' || locked} readOnly style={{ backgroundColor: theme.palette.background.color_373636, minWidth: '30rem', minHeight: '56px' }} defaultValue={requirement?.codes[digit]?.values?.get(index + 1)} />
            </React.Fragment>
          )
        }
        )}
      </div>
    </>
  )
}

export default Requirement
